import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/uaempci/manifest'
import {
  TablePage as VesselMasterTablePage,
  AddPage as VesselMasterAddPage,
  EditPage as VesselMasterEditPage,
  ViewPage as VesselMasterViewPage,
} from 'src/views/uaempci/VesselMaster'
import {
  TablePage as PartyMasterTablePage,
  AddPage as PartyMasterAddPage,
  EditPage as PartyMasterEditPage,
  ViewPage as PartyMasterViewPage,
} from 'src/views/uaempci/PartyMaster'
import {
  TablePage as MasterBillTablePage,
  AddPage as MasterBillAddPage,
  EditPage as MasterBillEditPage,
  ViewPage as MasterBillViewPage,
} from 'src/views/uaempci/MasterBill'
import {
  TablePage as HouseBillTablePage,
  AddPage as HouseBillAddPage,
  EditPage as HouseBillEditPage,
  ViewPage as HouseBillViewPage,
} from 'src/views/uaempci/HouseBill'
import DashboardPage from 'src/views/uaempci/Dashboard/DashboardPage'
import FileUploadPage from 'src/views/uaempci/Upload/FileUploadPage'
import UploadHistoryPage from 'src/views/uaempci/Upload/UploadHistoryPage'

import { ReportsPage } from 'src/views/uaempci/Reports/ReportsPage'
import UserSettingsPage from 'src/views/uaempci/UserSettings/UserSettingsPage'
import AppConfigPage from 'src/views/uaempci/AppConfig/AppConfigPage'
import CodeMaintenancePage from 'src/views/uaempci/CodeMaintenance/CodeMaintenancePage'
import pathMap from 'src/paths/pathMap'

class UaeMpciRoute {
  getConfigurations() {
    return [
      // Manifest (legacy POC table)
      {
        exact: true,
        path: pathMap.UAE_MPCI_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.UAE_MPCI_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.UAE_MPCI_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.UAE_MPCI_DETAILS_VIEW,
        component: ViewPage
      },
      // Dashboard
      {
        exact: true,
        path: pathMap.UAE_MPCI_DASHBOARD,
        component: DashboardPage
      },
      // Vessel Master
      {
        exact: true,
        path: pathMap.UAE_MPCI_VESSEL_MASTER_LIST_VIEW,
        component: VesselMasterTablePage
      },
      {
        exact: true,
        path: pathMap.UAE_MPCI_VESSEL_MASTER_ADD_VIEW,
        component: VesselMasterAddPage
      },
      {
        exact: true,
        path: pathMap.UAE_MPCI_VESSEL_MASTER_EDIT_VIEW,
        component: VesselMasterEditPage
      },
      {
        exact: true,
        path: pathMap.UAE_MPCI_VESSEL_MASTER_DETAILS_VIEW,
        component: VesselMasterViewPage
      },
      // Party Master
      {
        exact: true,
        path: pathMap.UAE_MPCI_PARTY_MASTER_LIST_VIEW,
        component: PartyMasterTablePage
      },
      {
        exact: true,
        path: pathMap.UAE_MPCI_PARTY_MASTER_ADD_VIEW,
        component: PartyMasterAddPage
      },
      {
        exact: true,
        path: pathMap.UAE_MPCI_PARTY_MASTER_EDIT_VIEW,
        component: PartyMasterEditPage
      },
      {
        exact: true,
        path: pathMap.UAE_MPCI_PARTY_MASTER_DETAILS_VIEW,
        component: PartyMasterViewPage
      },
      // Master Bill
      {
        exact: true,
        path: pathMap.UAE_MPCI_MASTER_BILL_LIST_VIEW,
        component: MasterBillTablePage
      },
      {
        exact: true,
        path: pathMap.UAE_MPCI_MASTER_BILL_ADD_VIEW,
        component: MasterBillAddPage
      },
      {
        exact: true,
        path: pathMap.UAE_MPCI_MASTER_BILL_EDIT_VIEW,
        component: MasterBillEditPage
      },
      {
        exact: true,
        path: pathMap.UAE_MPCI_MASTER_BILL_DETAILS_VIEW,
        component: MasterBillViewPage
      },
      // House Bill
      {
        exact: true,
        path: pathMap.UAE_MPCI_HOUSE_BILL_LIST_VIEW,
        component: HouseBillTablePage
      },
      {
        exact: true,
        path: pathMap.UAE_MPCI_HOUSE_BILL_ADD_VIEW,
        component: HouseBillAddPage
      },
      {
        exact: true,
        path: pathMap.UAE_MPCI_HOUSE_BILL_EDIT_VIEW,
        component: HouseBillEditPage
      },
      {
        exact: true,
        path: pathMap.UAE_MPCI_HOUSE_BILL_DETAILS_VIEW,
        component: HouseBillViewPage
      },
      // Upload
      {
        exact: true,
        path: pathMap.UAE_MPCI_FILE_UPLOAD,
        component: FileUploadPage
      },
      {
        exact: true,
        path: pathMap.UAE_MPCI_FILE_UPLOAD_HISTORY,
        component: UploadHistoryPage
      },
            // Reports
      {
        exact: true,
        path: pathMap.UAE_MPCI_REPORTS,
        component: ReportsPage
      },
            // User Settings
      {
        exact: true,
        path: pathMap.UAE_MPCI_USER_SETTINGS,
        component: UserSettingsPage
      },
      // App Config
      {
        exact: true,
        path: pathMap.UAE_MPCI_APP_CONFIG,
        component: AppConfigPage
      },
      // Code Maintenance
      {
        exact: true,
        path: pathMap.UAE_MPCI_CODE_MAINTENANCE,
        component: CodeMaintenancePage
      }
    ]
  }
}

export default UaeMpciRoute
